module.exports = __webpack_public_path__ + "uarm-images/ui-icons_444444_256x240.png";